import angular from 'angular';
import style from './style.scss'; 

export default function ($scope, $rootScope, $state, $interval, $http) {
    'ngInject';
    $scope.style = style;

    var idCategory = $state.params.id.split('-')[0];

    $scope.category = $rootScope.categoria;
    $scope.produtos = [];

    function makePaginator() {

        var pages = Number($rootScope.search.pagination.total / $rootScope.search.pagination.length),
            paginas = 0,
            iniPag = 0,
            fimPag = 0;

        pages = parseInt(pages, 0) < pages ? parseInt(pages, 0) + 1 : pages;
        $rootScope.search.pagination.totalPages = pages;

        if (pages > $rootScope.search.pagination.viewPages) {
            paginas = parseInt($rootScope.search.pagination.viewPages / 2, 0);
            if ($rootScope.search.pagination.page + paginas > pages) {
                iniPag = pages - $rootScope.search.pagination.viewPages + 1;
                fimPag = pages;
            } else {
                iniPag = (($rootScope.search.pagination.page) - paginas < 1) ? 1 : (parseInt(paginas / 2, 0) !== paginas / 2 ? ($rootScope.search.pagination.page) - (paginas) : ($rootScope.search.pagination.page) - (paginas - 1));
                fimPag = (iniPag + $rootScope.search.pagination.viewPages - 1 > pages) ? pages : iniPag + $rootScope.search.pagination.viewPages - 1;
                iniPag += (($rootScope.search.pagination.page) > fimPag - (paginas) && parseInt(paginas / 2, 0) !== paginas / 2) ? (fimPag - paginas) - ($rootScope.search.pagination.page) : 0;
                iniPag = parseInt(iniPag, 0);
            }
        } else {
            iniPag = 1;
            fimPag = pages;
        }

        $rootScope.search.pagination.pages = [];
        for (let i = iniPag; i <= fimPag; i++) {
            $rootScope.search.pagination.pages.push(i);
        }

    }

    $scope.buscar = function (page) {

        page = page || $state.params.page;
        page = Number(page);

        if (page) {
            $rootScope.search.pagination.page = page;
            $rootScope.search.pagination.offset = (page - 1) * $rootScope.search.pagination.length;
        }

        if ($rootScope.search.order === '1') {
            $rootScope.search.pagination.order = {
                nome: 'asc'
            };
        } else if ($rootScope.search.order === '2') {
            $rootScope.search.pagination.order = {
                nome: 'desc'
            };
        } else if ($rootScope.search.order === '3') {
            $rootScope.search.pagination.order = {
                valorreal: 'desc'
            };
        } else if ($rootScope.search.order === '4') {
            $rootScope.search.pagination.order = {
                valorreal: 'asc'
            };
        } 

        $rootScope.search.result = [];
        $rootScope.search.load = false;
        $http.get($scope.backURL + 'api/categorias/' + idCategory + '/produtos', {
            params: {
                offset: $rootScope.search.pagination.offset,
                limit: $rootScope.search.pagination.length,
                order: JSON.stringify($rootScope.search.pagination.order),
                valid: true
            }
        }).then(data => {
            $rootScope.search.result = data.data.data.result;
            $rootScope.search.pagination.total = data.data.data.total;
            $rootScope.search.result = $rootScope.search.result.map(p => $rootScope.configProduto(p));
            $interval(() => {
                $rootScope.search.load = true;
                makePaginator();
            }, 100, 1);
        });

    };

    if ($rootScope.search.category === undefined || $rootScope.search.category.id !== idCategory) {
        let idI = $interval(() => {
            if ($rootScope.produtosPorPagina !== undefined) {
                angular.extend($rootScope.search, {
                    pagination: {
                        offset: 0,
                        length: $rootScope.produtosPorPagina,
                        total: 0,
                        viewPages: 10,
                        totalPages: 1,
                        order: {
                            nome: 'asc'
                        },
                        pages: [],
                        page: 1,
                        url: '/categoria/' + $state.params.id + '-' + $state.params.url + '/'
                    },
                    category: {},
                    brand: {},
                    term: undefined,
                    result: [],
                    breadcrumb: [],
                    order: '1'
                });

                $http.get($scope.backURL + 'api/categorias/' + idCategory).then(function (data) {
                    $rootScope.search.category = $scope.category = data.data.data;
                });
                $interval.cancel(idI);
                $scope.buscar();
            }
        }, 1000);

        $rootScope.search = {
            result: [],
            total: 0,
            load: false
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/views/app.category/index.js